"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGovActionLike = exports.toRealGovAction = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var GovAcitonUpdateCommittee_1 = require("./GovAcitonUpdateCommittee.js");
var GovActionInfo_1 = require("./GovActionInfo.js");
var GovActionInitHardFork_1 = require("./GovActionInitHardFork.js");
var GovActionNewConstitution_1 = require("./GovActionNewConstitution.js");
var GovActionNoConfidence_1 = require("./GovActionNoConfidence.js");
var GovActionParameterChange_1 = require("./GovActionParameterChange.js");
var GovActionTreasuryWithdrawals_1 = require("./GovActionTreasuryWithdrawals.js");
var GovActionType_1 = require("./GovActionType.js");
function toRealGovAction(govActionLike) {
    switch (govActionLike.govActionType) {
        case GovActionType_1.GovActionType.ParameterChange: return new GovActionParameterChange_1.GovActionParameterChange(govActionLike);
        case GovActionType_1.GovActionType.InitHardFork: return new GovActionInitHardFork_1.GovActionInitHardFork(govActionLike);
        case GovActionType_1.GovActionType.TreasuryWithdrawals: return new GovActionTreasuryWithdrawals_1.GovActionTreasuryWithdrawals(govActionLike);
        case GovActionType_1.GovActionType.NoConfidence: return new GovActionNoConfidence_1.GovActionNoConfidence(govActionLike);
        case GovActionType_1.GovActionType.UpdateCommittee: return new GovAcitonUpdateCommittee_1.GovActionUpdateCommittee(govActionLike);
        case GovActionType_1.GovActionType.NewConstitution: return new GovActionNewConstitution_1.GovActionNewConstitution(govActionLike);
        case GovActionType_1.GovActionType.Info: return new GovActionInfo_1.GovActionInfo(govActionLike);
        default: throw new Error("unknown govAcitonType");
    }
}
exports.toRealGovAction = toRealGovAction;
function isGovActionLike(stuff) {
    if (!((0, obj_utils_1.isObject)(stuff) &&
        (0, GovActionType_1.isGovActionType)(stuff.govActionType)))
        return false;
    switch (stuff.govAcitonType) {
        case GovActionType_1.GovActionType.ParameterChange: return (0, GovActionParameterChange_1.isIGovActionParameterChange)(stuff);
        case GovActionType_1.GovActionType.InitHardFork: return (0, GovActionInitHardFork_1.isIGovActionInitHardFork)(stuff);
        case GovActionType_1.GovActionType.TreasuryWithdrawals: return (0, GovActionTreasuryWithdrawals_1.isIGovActionTreasuryWithdrawals)(stuff);
        case GovActionType_1.GovActionType.NoConfidence: return (0, GovActionNoConfidence_1.isIGovActionNoConfidence)(stuff);
        case GovActionType_1.GovActionType.UpdateCommittee: return (0, GovAcitonUpdateCommittee_1.isIGovActionUpdateCommittee)(stuff);
        case GovActionType_1.GovActionType.NewConstitution: return (0, GovActionNewConstitution_1.isIGovActionNewConstitution)(stuff);
        case GovActionType_1.GovActionType.Info: return (0, GovActionInfo_1.isIGovActionInfo)(stuff);
        default: throw new Error("unknown govAcitonType");
    }
}
exports.isGovActionLike = isGovActionLike;
